<template>
  <div class="payInfoTable">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="payInfoTableRef"
      class="vxe-table-element"
      :footer-method="footerMethod"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="payOrderColumn"
      :show-footer="true"
    >
      <vxe-table-column
        v-for="(item, index) in payOrderColumn"
        :key="index"
        :fixed="item.fixed"
        :visible="item.visible"
        :width="item.width || 120"
        :sortable="item.sortable"
        :field="item.field"
        :formatter="item.formatter"
        :params="item.params"
        :type="item.type"
      >
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'payInfoTable',
    components: {
      // SearchTable,
      // inputNumberAd,
    },
    props: ['sysConfigFlag', 'canEdit', 'basicInfo'],
    data() {
      return {
        tableData: [],
        addRowObj: {
          id: null,
          contractNo: null, //付款单号
          externalContractNo: null, //付款日期
          apportionAmount: null, //付款金额
          customerNo: null, //付款银行账户名称
          customerName: null, //付款银行账号
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 付款申请明细
      payOrderColumn() {
        return [
          {
            // 序号
            type: 'seq',
            width: 80,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.payableInvoiceDetailNo'),
          },
          {
            //公司
            field: 'paymentCompanyName',
            title: '公司名称',
            width: 200,
          },
          {
            //部门
            field: 'paymentDepartmentName',
            title: '部门',
            width: 200,
          },
          {
            //付款申请单号
            field: 'paymentApplyNumber',
            title: '付款申请单号',
            width: 200,
          },
          {
            //付款申请单行号
            field: 'paymentApplyLineNumber',
            title: '付款申请单行号',
            width: 200,
          },
          {
            //付款单号
            field: 'paymentOrderNo',
            title: '付款单号',
            width: 200,
          },
          {
            //付款日期
            field: 'paymentDate',
            title: '付款日期',
            width: 120,
          },
          {
            //实际付款金额
            field: 'actualPaymentAmount',
            title: '实际付款金额',
            width: 150,
            format: 'formatAmount',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.actualPaymentAmount)}</span>,
                ];
              },
            },
          },
          {
            //付款方式
            field: 'paymentMethod',
            title: '付款方式',
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.getDictValueByType(
                      'apply_payment_method',
                      row.paymentMethod
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            //收款方名称
            field: 'payeeName',
            title: '收款方名称',
            width: 120,
          },
          {
            //付款状态
            field: 'paymentStatus',
            title: '付款状态',
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.getDictValueByType('payment_status', row.paymentStatus)}
                  </span>,
                ];
              },
            },
          },
          {
            //付款入账状态
            field: 'paymentEntryStatus',
            title: '付款入账状态',
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {row.paymentEntryStatus == '1'
                      ? '已入账'
                      : row.paymentEntryStatus == '0'
                      ? '未入账'
                      : ''}
                  </span>,
                ];
              },
            },
          },
          {
            //付款的入账日期
            field: 'paymentEntryDate',
            title: '付款的入账日期',
            width: 120,
          },
          {
            //付款银行流水号
            field: 'paymentBankSerialNumber',
            title: '付款银行流水号',
            width: 120,
          },
          {
            //付款银行账户名称
            field: 'paymentBankAccountNo',
            title: '付款银行账号',
            width: 200,
          },
          {
            //票据号
            field: 'billNo',
            title: '票据号',
            width: 120,
          },
          {
            //信用证编号
            field: 'creditNo',
            title: '信用证编号',
            width: 120,
          },
        ];
      },
    },
    mounted() {},
    methods: {
      async getData(billCode) {
        if (billCode) {
          let res = await this.$axios.post('/financial/paymentApply/getPaymentApplyByBillNo', {
            billNo: billCode,
          });
          if (res) {
            if (res.data.code == 0) {
              this.tableData = res.data.data || [];
            }
          }
        }
      },
      footerMethod({ columns, data }) {
        data = data.filter((item) => item.paymentStatus == 'Paid');
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['actualPaymentAmount'].includes(column.property)) {
              return data
                .map((i) => i['actualPaymentAmount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                  return this.$baseRequest.formatTableColumn(num);
                }, 0);
            }
          }),
        ];
      },
    },
  };
</script>
